module.exports = __webpack_public_path__ + "img/cf_img_bg.9fc9b446.png";